var map = {
	"./pattern_1.png": "d332",
	"./pattern_2.png": "5780",
	"./pattern_3.png": "4c08",
	"./pattern_4.png": "20c3",
	"./pattern_5.png": "1c5f",
	"./pattern_6.png": "e241",
	"./pattern_7.png": "a5e7",
	"./pattern_8.png": "1213",
	"./pattern_9.png": "ea26"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9f03";